var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "justify-space-between", attrs: { fluid: "" } },
    [
      !_vm.item
        ? _c("v-progress-circular", { attrs: { indeterminate: "" } })
        : _vm.item && _vm.item.type === "wells"
        ? _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _vm.predictTaskFinished
                ? _c("adapt-result", {
                    attrs: {
                      item: _vm.item,
                      task: _vm.predictTask,
                      "optimize-task": _vm.wellsTask,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _vm.predictTaskFinished
                ? _c("adapt-result", {
                    attrs: {
                      item: _vm.item,
                      task: _vm.predictTask,
                      "optimize-task": _vm.task,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }